import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container" style={{ width: "100%" }}>
        <div className="col-md-12 section-title" style={{ marginTop: "20px" }}>
          <h2>Features</h2>
        </div>
        <div>
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className={`col-xs-6 col-md-2 ${
                    i === 0 ? "col-md-offset-1" : ""
                  }`}
                >
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
